



















































































































































import Vue from "vue";
import { mapGetters } from "vuex";
import * as moment from "moment";
import _ from "lodash";
import { AxiosResponse } from "axios";

// Vue Components
import DownloadLogsOnDemandProgressCard from "./DownloadLogsOnDemandProgressCard.vue";
import InstallationLogAnalysis from "@/views/App/PredictiveMaintenance/LogAnalysis/InstallationLogAnalysis.vue";
import LogAnalysisOnDemandCard from "@/views/App/PredictiveMaintenance/LogAnalysis/LogAnalysisOnDemandCard.vue";

// Model
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { GetInstallationsReqData } from "@/model/communication/device/GetInstallationsReqData";
import { GetInstallationsResData } from "@/model/communication/device/GetInstallationsResData";
import { GetInstallationsCommand } from "@/model/communication/device/GetInstallationsCommand";
import { DownloadLogsIfExistCommand } from "@/model/communication/downloadLogs/DownloadLogsIfExistCommand";
import { ForceLogsDownloadOnDemandCommand } from "@/model/communication/downloadLogs/ForceLogsDownloadOnDemandCommand";
import { GetDownloadOnDemandProgressCommand } from "@/model/communication/downloadLogs/GetDownloadOnDemandProgressCommand";
import { DownloadLogsReqData } from "@/model/communication/downloadLogs/DownloadLogsReqData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { getLogTypesFromLogsFamily } from "@/model/data/enums/LogsTypeEnum";
import { getName, LogsFamilyEnum } from "@/model/data/enums/LogsFamilyEnum";
import { DownloadLogsProgressResData } from "@/model/communication/downloadLogs/DownloadLogsProgressResData";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { MODULE_COLORS } from "@/utility/Constants";
import { AnalyzeLogNowCommand, AnalyzeLogNowReqData } from "@/model/communication/logAnalysis/AnalyzeLogNowCommand";
import { ServiceResponseData } from "@/model/communication/ServiceResponseData";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

const maxDaysRange = 30;

export default Vue.extend({
    components: {
        DownloadLogsOnDemandProgressCard,
        InstallationLogAnalysis,
        LogAnalysisOnDemandCard,
    },
    data() {
        return {
            MODULE_COLORS,
            selectedInstallations: [],
            selectedMachineSNsForDownloadOnDemand: [],
            installation: null,
            dateRange: [],
            logsTypeRadio: LogsFamilyEnum.Application,
            showOnDemandAlertDialog: false,
            showAlert: false,
            alertType: "info",
            alertMessage: null,
            downloadLogsProgress: {},
            analysisLogsProgress: {},
            isPollingEnabled: false,
            onDownloadLogsButton_loading: false,
            showAnalyzeDialog: false,
            analysisInstallation: null,
            analysisStartDate: null,
            analysisEndDate: null,
            analyzeAfterDownload: false,
            analysisLoading: false,
            rerender: 0,
            analysisError: false,
            analysisNotSupportedError: false,
            analysisLicenseError: false,
            defaultDateRanges: [
                {
                    id: "today",
                    i18nLabel: "common.today",
                    value: 0,
                },
                {
                    id: "lastWeek",
                    i18nLabel: "common.lastWeek",
                    value: 1,
                },
                {
                    id: "last2Weeks",
                    i18nLabel: "common.last2Weeks",
                    value: 2,
                },
                {
                    id: "customDateRange",
                    i18nLabel: "",
                    value: 3,
                },
            ],
            radioSelection: 0,
            isMounted: false,
        };
    },
    props: ["deviceTreeSelectedObjectItems", "installationsProp"],
    computed: {
        ...mapGetters(["userDateFormat", "authUserHasPrivilege"]),

        isMobileDevice() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        sortedDateRangeFormatted() {
            let formatted = [];
            if (this.sortedDateRange != null && this.sortedDateRange != undefined) this.sortedDateRange.forEach((dt) => formatted.push(moment(dt).format(this.userDateFormat)));
            return formatted;
        },
        sortedDateRange() {
            return _(this.dateRange).sort();
        },
        errorMessage() {
            let res = [];
            const date1 = new Date(this.dateRange[0]);
            const date2 = new Date(this.dateRange[1]);
            const diffTime = Math.abs((date2 as any) - (date1 as any));
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays >= maxDaysRange) res.push(this.$t("downloadLogs.maxDaysRangeError", { maxDaysRange: maxDaysRange }));
            else if (this.dateRange.length != 2) res.push(this.$t("downloadLogs.selectionRangeError"));
            return res;
        },
        downloadBtnHintLabel() {
            if (this.dateRange.length != 2) return this.$t("downloadLogs.selectionRangeError");
            const date1 = new Date(this.dateRange[0]);
            const date2 = new Date(this.dateRange[1]);
            const diffTime = Math.abs((date2 as any) - (date1 as any));
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays >= maxDaysRange) return this.$t("downloadLogs.maxDaysRangeError", { maxDaysRange: maxDaysRange });
            if (this.selectedInstallations != null) {
                if (this.selectedInstallations.length < 1) return this.$t("downloadLogs.selectOneInstallation");
                else if (this.selectedInstallations.length == 1) return null;
                else if (this.selectedInstallations.length > 1) return this.$t("downloadLogs.selectOnlyOneInstallation");
                else return null;
            } else return this.$t("downloadLogs.selectOneInstallation");
        },
        availableMachines() {
            if (this.installation && this.logsTypeRadio == LogsFamilyEnum.Machine && this.installation.machines.length > 1)
                return this.installation.machines.filter((m) => m.model != "DropVault");
            else return [];
        },
        logAnalysisEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.LogAnalysis);
        },
        downloadOnlyDbEnabled() {
            if (this.dateRange[0] == moment().utc().format("YYYY-MM-DD") && this.dateRange[1] == moment().utc().format("YYYY-MM-DD")) return false;
            if (this.radioSelection != 0) return true;
            return false;
        },
        containerWidth() {
            if (this.isMounted && this.$refs && this.$refs.containerDownload) return this.$refs.containerDownload.clientWidth;
            return 0;
        },
    },
    watch: {
        installationsProp(newValue) {
            this.selectedInstallations = [];
            if (newValue) this.selectedInstallations = newValue.map((c) => c.name);
        },
        deviceTreeSelectedObjectItems(newValue) {
            this.selectedInstallations = [];
            if (newValue) {
                this.resetVariables();
                if (newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).length > 0)
                    this.selectedInstallations = newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
            }
        },
        showAnalyzeDialog: {
            handler(val) {
                document.querySelector("html").style.overflowY = val ? "hidden" : "auto";
            },
            immediate: true,
        },
        radioSelection: {
            handler(value) {
                let startDateTemp = null;
                let endDateTemp = moment().utc();

                switch (value) {
                    case 0:
                        startDateTemp = moment().utc();
                        break;
                    case 1:
                        endDateTemp = moment().subtract(1, "day").utc();
                        startDateTemp = moment().subtract(1, "day").subtract(1, "weeks").utc();
                        break;
                    case 2:
                        endDateTemp = moment().subtract(1, "day").utc();
                        startDateTemp = moment().subtract(1, "day").subtract(2, "weeks").utc();
                        break;
                    default:
                        break;
                }
                if (value < 3) {
                    this.dateRange.splice(0);
                    this.dateRange.push(moment(startDateTemp).format("YYYY-MM-DD"), moment(endDateTemp).format("YYYY-MM-DD"));
                }
            },
            immediate: true,
        },
    },
    methods: {
        // metodi per l'interfaccia
        stopPolling() {
            this.isPollingEnabled = false;
        },
        resetVariables() {
            this.showAlert = false;
            this.stopPolling();
            this.downloadLogsProgress = {};
            this.analysisLogsProgress = {};
            this.analysisLoading = false;
            this.onDownloadLogsButton_loading = false;
        },
        showGenericErrorAlert() {
            this.alertMessage = this.$t("downloadLogs.serverError");
            this.alertType = "error";
            this.showAlert = true;
        },
        // metodi con richieste al server
        async sendRequestDownloadAndAnalyzeNow(fromForce) {
            try {
                this.analysisStartDate = new Date(this.sortedDateRange.at(0));
                this.analysisStartDate = new Date(Date.UTC(this.analysisStartDate.getFullYear(), this.analysisStartDate.getMonth(), this.analysisStartDate.getDate(), 0, 0, 0));
                this.analysisEndDate = new Date(this.sortedDateRange.at(1));
                this.analysisEndDate = new Date(Date.UTC(this.analysisEndDate.getFullYear(), this.analysisEndDate.getMonth(), this.analysisEndDate.getDate(), 23, 59, 59));

                if (!fromForce) await this.onDownloadLogsButton();
                if (this.showOnDemandAlertDialog) {
                    this.analyzeAfterDownload = true;
                    return;
                }
                this.analysisError = false;
                this.analysisLicenseError = false;
                this.analysisNotSupportedError = false;
                this.analysisInstallation = this.installation;

                this.analysisLogsProgress.startDate = this.analysisStartDate;
                this.analysisLogsProgress.endDate = this.analysisEndDate;
                this.analysisLogsProgress.installationName = this.analysisInstallation.name;
                this.analysisLogsProgress.machineSerialNumbers = this.analysisInstallation.machines.map((m) => m.serialNumber);

                this.analysisLoading = true;
                let reqData: AnalyzeLogNowReqData = new AnalyzeLogNowReqData(this.analysisInstallation.name, this.analysisStartDate, this.analysisEndDate);
                let res: ServiceResponseData = await new AnalyzeLogNowCommand(reqData).execute();
                if (res.message == CReqExecutionResultEnum.InvalidRequest) {
                    this.analysisLicenseError = true;
                    let dateOffset = (24 * 60 * 60 * 5 - 1) * 1000;
                    this.analysisStartDate.setTime(this.analysisEndDate.getTime() - dateOffset);
                } else if (res.message == CReqExecutionResultEnum.ServerError) this.analysisError = true;
                else if (res.message == CReqExecutionResultEnum.OperationNotAvailable) this.analysisNotSupportedError = true;
                this.analysisLoading = false;
                this.rerender += 1;
                this.analyzeAfterDownload = false;
            } catch (error) {
                console.error("Error in get installations: ", error);
                this.showGenericErrorAlert();
                this.analysisLoading = false;
                return;
            }
        },
        createDownloadLogsReqData(ignoreMissingEntries: boolean = false) {
            let reqData: DownloadLogsReqData = new DownloadLogsReqData();
            reqData.installationName = this.selectedInstallations.at(0);
            if (this.selectedMachineSNsForDownloadOnDemand.length > 0) reqData.machineSerialNumbers = this.selectedMachineSNsForDownloadOnDemand;
            else if (this.installation.machines.map((m) => m.serialNumber) != null)
                this.installation.machines
                    .map((m) => m.serialNumber)
                    .forEach((sn) => {
                        reqData.machineSerialNumbers.push(sn);
                    });
            reqData.startDate = new Date(this.sortedDateRange.at(0));
            reqData.endDate = new Date(this.sortedDateRange.at(1));
            reqData.logsFamily = this.logsTypeRadio as LogsFamilyEnum;
            reqData.logTypes = getLogTypesFromLogsFamily(this.logsTypeRadio as LogsFamilyEnum);
            reqData.ignoreMissingEntries = ignoreMissingEntries;
            return reqData;
        },
        async onDownloadLogsButton() {
            try {
                this.onDownloadLogsButton_loading = true;
                this.selectedMachineSNsForDownloadOnDemand = [];
                this.resetVariables();

                // recupero le informazioni per l'installazione selezionata (se è diversa da quella che ho in memoria)
                try {
                    if (this.installation == null || (this.installation != null && this.installation.name != this.selectedInstallations.at(0))) {
                        let installationNames = [];
                        installationNames.push(this.selectedInstallations.at(0));
                        let res: GetInstallationsResData = await new GetInstallationsCommand(new GetInstallationsReqData(installationNames)).execute();
                        if (res.responseStatus == ApiResponseStatusEnum.Success)
                            if (Array.isArray(res.installations) && res.installations.length > 0) this.installation = res.installations[0];
                    }
                } catch (error) {
                    console.error("Error in get installations: ", error);
                    this.showGenericErrorAlert();
                    this.onDownloadLogsButton_loading = false;
                    return;
                }

                if (this.installation.installedSoftwares.filter((s) => s.updateType == UpdateTypeEnum.Agent).length > 0)
                    if (this.installation.installedSoftwares.filter((s) => s.updateType == UpdateTypeEnum.Agent)[0].version.startsWith("5"))
                        if (this.logsTypeRadio == LogsFamilyEnum.Application) {
                            this.alertMessage = this.$t("downloadLogs.applicationLogsNotAvailableForAgent5");
                            this.alertType = "warning";
                            this.showAlert = true;
                            this.onDownloadLogsButton_loading = false;
                            return;
                        }

                // se sto richiedendo log applicativi o log per la giornata odierna (macchina o applicativi), allora verranno chiesti on demand
                if (this.logsTypeRadio == LogsFamilyEnum.Application || this.sortedDateRange.at(1) == moment(new Date()).format("YYYY-MM-DD")) {
                    this.showOnDemandAlertDialog = true;
                } else {
                    // altrimenti controllo sul db, se ci sono li scarico, altrimenti eventulamente li scaricherò on demand
                    let resStatus = await this.downloadLogsIfExist(null);
                    if (resStatus == 204) this.showOnDemandAlertDialog = true;
                    if (this.analyzeAfterDownload && !this.showAlert) {
                        this.sendRequestDownloadAndAnalyzeNow(true);
                    }
                }
                this.onDownloadLogsButton_loading = false;
            } catch (error) {
                console.error("Error in onDownloadLogsButton(): ", error);
                this.onDownloadLogsButton_loading = false;
            }
        },
        async downloadLogsIfExist(reqData: DownloadLogsReqData, ignoreMissingEntries: boolean = false) {
            try {
                this.onDownloadLogsButton_loading = true;
                if (reqData == null) reqData = this.createDownloadLogsReqData(ignoreMissingEntries);
                let res: AxiosResponse = await new DownloadLogsIfExistCommand(reqData).execute();
                if (res.status == 200) {
                    let now: Date = new Date();
                    let formattedDate = moment(now).format("YYYY-MM-DD_HHmmss");
                    let fileName = formattedDate + "_" + reqData.installationName + "_" + getName(reqData.logsFamily) + ".zip";
                    let fileLink = document.createElement("a");
                    fileLink.href = window.URL.createObjectURL(res.data as Blob);
                    fileLink.setAttribute("download", fileName);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }
                this.onDownloadLogsButton_loading = false;
                return res.status;
            } catch (error) {
                console.error("downloadLogsIfExist(): ", error);
                this.onDownloadLogsButton_loading = false;
                return 0;
            }
        },
        async forceLogsDownloadOnDemand() {
            this.onDownloadLogsButton_loading = true;
            try {
                let reqData: DownloadLogsReqData = this.createDownloadLogsReqData();
                let res: DownloadLogsProgressResData = await new ForceLogsDownloadOnDemandCommand(reqData).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    if (res.message) {
                        switch (res.message) {
                            case CReqExecutionResultEnum.AgentOffline:
                                this.alertMessage = this.$t("downloadLogs.agentOfflineForInstallation");
                                this.alertType = "warning";
                                this.showAlert = true;
                                break;
                            case CReqExecutionResultEnum.AgentNotInstalled:
                                this.alertMessage = this.$t("downloadLogs.agentNotInstalled");
                                this.alertType = "error";
                                this.showAlert = true;
                                break;
                            case CReqExecutionResultEnum.DeviceLocked:
                                this.alertMessage = this.$t("downloadLogs.agentLocked");
                                this.alertType = "warning";
                                this.showAlert = true;
                                break;
                            case CReqExecutionResultEnum.OperationNotAvailable:
                                this.alertMessage = this.$t("downloadLogs.operationNotAvailable");
                                this.alertType = "info";
                                this.showAlert = true;
                                this.startProgressPolling(reqData.installationName);
                                break;
                            case CReqExecutionResultEnum.ServerError:
                                this.showGenericErrorAlert();
                                break;
                            default:
                                break;
                        }
                        this.onDownloadLogsButton_loading = false;
                    } else {
                        this.startProgressPolling(reqData.installationName);
                    }
                } else {
                    console.error("RES: ", res);
                    this.onDownloadLogsButton_loading = false;
                }
            } catch (error) {
                console.error("forceLogsDownloadOnDemand(): ", error);
                this.onDownloadLogsButton_loading = false;
            }
            this.showOnDemandAlertDialog = false;
            this.selectedMachineSNsForDownloadOnDemand = [];
        },
        async startProgressPolling(installationName: string) {
            console.log("START PROGRESS POLLING for installation: ", installationName);
            this.isPollingEnabled = true;
            let res: DownloadLogsProgressResData;
            while (this.isPollingEnabled) {
                try {
                    res = await new GetDownloadOnDemandProgressCommand(installationName).execute();
                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        this.downloadLogsProgress = res.downloadLogsProgress;
                        // se lo scaricamento on demand ha finito, scarico i log dal database
                        if (res.downloadLogsProgress.isDownloadCompleted) {
                            let request: DownloadLogsReqData = res.downloadLogsProgress.getDownloadLogsReqData();
                            request.ignoreMissingEntries = true; // prendo giù tutto quello che l'agent è riuscito a scaricare
                            this.stopPolling();
                            let resStatus = await this.downloadLogsIfExist(request);
                            if (resStatus == 204) {
                                this.alertMessage = this.$t("downloadLogs.somethingWrong");
                                this.alertType = "warning";
                                this.showAlert = true;
                            }
                            this.onDownloadLogsButton_loading = false;
                            if (this.analyzeAfterDownload && (!this.showAlert || (this.showAlert && this.alertType == "info"))) {
                                this.sendRequestDownloadAndAnalyzeNow(true);
                            }
                        }
                    }
                } catch (error) {
                    console.error("Errors GetDownloadOnDemandProgressCommand(): ", error);
                    this.stopPolling();
                }

                let timeout = 1000;
                if (res.downloadLogsProgress.logsFamily == LogsFamilyEnum.Machine) timeout = 10000;
                if (res.downloadLogsProgress.agentVersion.startsWith("5")) timeout = 10000;

                await new Promise((f) => setTimeout(f, timeout));
            }
        },
        downloadOnlyFromDb() {
            this.downloadLogsIfExist(null, true);
            this.showOnDemandAlertDialog = false;
        },
    },
    async mounted() {
        this.dateRange = [moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")];
        if (this.installationsProp) this.selectedInstallations = this.installationsProp.map((c) => c.name);
        this.isMounted = true;
    },
    beforeDestroy() {
        document.querySelector("html").style.overflowY = "auto";
    },
});
